var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVecSloop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1111,
    height: 951,
    viewBox: "0 0 1111 951",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 112V828.5L519 951L1111 697L1027 311.5L434 55.5002L118.5 0.000244141L0 112Z",
    fill: "#ADD7F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVecSloop);
export default __webpack_public_path__ + "static/media/vec_sloop.b27188f063034ee40a47ac2b39d98002.svg";
export { ForwardRef as ReactComponent };